const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0]?.payload || {};
    const amt = parseFloat(data.amt);
    const qty = data.QTY ?? 0;

    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "10px 15px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          zIndex: 9999,
          minWidth: "140px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <p
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            marginBottom: 8,
            color: "#000",
          }}
        >
          {data.date || "N/A"}
        </p>

        <p style={{ margin: "2px 0 0 0", fontSize: "14px" }}>
          Qty: <strong>{qty}</strong>
        </p>

        <p style={{ fontSize: "15px", margin: 0 }}>
          Amt :{" "}
          <span style={{ fontWeight: 500, color: "#6a0dad" }}>
            {isNaN(amt) ? "0.00" : amt.toFixed(2)}
          </span>
        </p>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
